import Cookies from 'js-cookie';
import { updateClientMarketingConsent } from './client';

const cookiesConsentRequired: string = 'cookies-consent-required';
const cookiesConsentAnalytics: string = 'cookies-consent-analytics';
const cookiesConsentMarketing: string = 'cookies-consent-marketing';

export const isCookiesAccepted = () => {
  return (
    Cookies.get(cookiesConsentRequired) === 'true' &&
    Cookies.get(cookiesConsentAnalytics) &&
    Cookies.get(cookiesConsentMarketing)
  );
};

export const isAnalyticCookiesAccepted = () => {
  return Cookies.get(cookiesConsentAnalytics) === 'true';
};

export const isMarketingCookiesAccepted = () => {
  return Cookies.get(cookiesConsentMarketing) === 'true';
};

export const acceptCookies = (analyticsAccepted: boolean, marketingAccepted: boolean) => {
  Cookies.set(cookiesConsentRequired, 'true', { secure: true, expires: 365 });
  Cookies.set(cookiesConsentAnalytics, analyticsAccepted.toString(), { secure: true, expires: 365 });
  Cookies.set(cookiesConsentMarketing, marketingAccepted.toString(), { secure: true, expires: 365 });
  updateClientMarketingConsent();
};
